import { createContext, useContext, useReducer } from "react";

const formReducer = (state, action) => {
  switch (action.type) {
    case "set_data":
      return {
        ...state,
        veicolo: action.veicolo,
        cliente: action.cliente,
        legale: action.legale,
        preventivi: action.preventivi,
        errors: action.errors,
        statoAssicurativo: { idStatoAssicurativo: "", targa: "" },
      };
    case "update_preventivo": {
      const { typePrev, idUID, preventivo } = action.payload;
      return {
        ...state,
        preventivi: {
          ...state.preventivi,
          [typePrev]: state.preventivi[typePrev].map((prev) =>
            prev.idUID === idUID ? preventivo : prev,
          ),
        },
      };
    }
    case "UPDATE_VEICOLO_FIELD": {
      return {
        ...state,
        veicolo: {
          ...state.veicolo,
          [action.payload.field]:
            typeof state.veicolo[action.payload.field] === "object" &&
            state.veicolo[action.payload.field]?.value !== undefined
              ? {
                  ...state.veicolo?.[action.payload.field],
                  value: action.payload.value,
                }
              : action.payload.value,
        },
      };
    }

    case "UPDATE_CLIENTE": {
      return {
        ...state,
        cliente: {
          ...state.cliente,
          ...Object.entries(action.payload).reduce((acc, [key, value]) => {
            const current = state.cliente[key];

            acc[key] =
              typeof current === "object" && current?.value !== undefined
                ? { ...current, value } // aggiorna solo value del select
                : value; // aggiorna valore semplice (stringa, numero, ecc.)

            return acc;
          }, {}),
        },
      };
    }
    case "UPDATE_LEGALE":
      return {
        ...state,
        legale: {
          ...state.legale,
          ...Object.entries(action.payload).reduce((acc, [key, value]) => {
            const current = state.legale[key];

            acc[key] =
              typeof current === "object" && current?.value !== undefined
                ? { ...current, value } // aggiorna solo value del select
                : value; // aggiorna valore semplice (stringa, numero, ecc.)

            return acc;
          }, {}),
        },
      };
    case "UPDATE_CONTATTI_CLIENTE":
      return {
        ...state,
        cliente: {
          ...state.cliente,
          contatti: action.payload, // always replace with new array
        },
      };
    case "UPDATE_CONTATTI_LEGALE":
      return {
        ...state,
        legale: {
          ...state.legale,
          contatti: action.payload, // always replace with new array
        },
      };
    case "set_errors":
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.scope]: action.payload,
        },
      };
    case "set_statoAssicurativo":
      return {
        ...state,
        statoAssicurativo: {
          ...state.statoAssicurativo,
          [action.name]: action.payload,
        },
      };
    case "UPDATE_MESSAGGI":
      return {
        ...state,
        messaggi: action.payload,
      };
    case "CLEAR_ON_DETAILS": {
      const { typePrev } = action.payload;
      if (!state.preventivi[typePrev]) return state;
      return {
        ...state,
        preventivi: {
          ...state.preventivi,
          [typePrev]: state.preventivi[typePrev].map((prev) => ({
            ...prev,
            onDetails: 0,
          })),
        },
      };
    }
    case "DOCUMENTI": {
      const { documenti } = action.payload;
      return { ...state, documenti };
    }
    case "NEW_DOCUMENT": {
      const { nome, dataCaricamento, tOb, idUidDocumento } = action.payload;
      const newDocument = {
        nome,
        dataCaricamento,
        tOb,
        idUidDocumento,
      };
      return { ...state, documenti: [...state.documenti, newDocument] };
    }
    case "UPDATE_DOCUMENTO": {
      const { idUidDoc, updates } = action.payload;
      return {
        ...state,
        documenti: state.documenti.map((doc) =>
          doc.idUidDocumento === idUidDoc ? { ...doc, ...updates } : doc,
        ),
      };
    }
    case "SET_ACTIVE_TAB":
      return {
        ...state,
        activeTab: action.payload,
      };
    case "SET_MODIFICA_MODE":
      return {
        ...state,
        isModificaMode: action.payload,
      };
    default:
      return state;
  }
};

const ContextRCAutoDetails = createContext(null);

const initialData = {
  veicolo: {},
  cliente: {},
  legale: {},
  preventivi: {},
  activeTab: null,
  isModificaMode: false,
  messaggi: [],
  errors: {
    Veicolo: {},
    Cliente: {},
    Legale: {},
  },
  documenti: [],
};

export const FormRCAutoDetailsProvider = ({ children }) => {
  const [formState, dispatch] = useReducer(formReducer, initialData);

  return (
    <ContextRCAutoDetails.Provider value={{ formState, dispatch }}>
      {children}
    </ContextRCAutoDetails.Provider>
  );
};

// Hook to use form context
export const useFormRCAutoDetails = () => {
  const context = useContext(ContextRCAutoDetails);
  if (!context) {
    throw new Error("useForm must be used within a FormProvider");
  }
  return context;
};
